<template>
  <div>
    <Header v-if="!loading" :code="code" :team_id="team_id" points="-" />

    <section
      v-if="game.teams"
      style="position: relative; height: 92.5vh !important; overflow: scroll !important;"
    >
      <div class="cont-fullwidth white-text black-bg">
        <div class="row d-flex align-items-center vh-20">
          <div class="col-12 text-center">
            <h3 class="termina-black" style="text-transform: uppercase;">
              {{ leaderboardTitle }} Leaderboard
            </h3>
          </div>
        </div>
      </div>

      <!-- background texture layer -->
      <div class="game-texture-layer"></div>

      <div class="cont-fullwidth black-bg">
        <div
          class="row pad-left-30 pad-right-30"
          style="height: 100% !important; padding-bottom: 30px"
        >
          <!-- leaderboard items -->

          <div class="col-12 d-flex white-text">
            <div class="flex-fill count-width"></div>
            <div class="flex-fill team-width">
              <p class="termina-black pb-0 mb-0 mt-0">Team</p>
            </div>
            <div class="flex-fill score-width">
              <p class="termina-black pb-0 mb-0 mt-0">Score</p>
            </div>
            <div class="flex-fill progress-width hidden-mobile">
              <p class="termina-black mt-0">Completed</p>
            </div>
          </div>

          <div
            v-for="(item, index) in teams"
            :key="item.teamName"
            class="col-12 d-flex leaderboard-item shadow"
          >
            <div class="flex-fill count-width">
              <h2 class="termina-black pb-0 mb-0 mt-0">
                <div class="circle-number">{{ index + 1 }}</div>
              </h2>
            </div>
            <div class="flex-fill team-width">
              <h2 class="termina-reg pb-0 mb-0 mt-0">
                {{ item.teamName }}
              </h2>
            </div>
            <div class="flex-fill score-width">
              <h2 class="termina-reg pb-0 mb-0 mt-0">{{ item.points }}</h2>
            </div>
            <div class="flex-fill progress-width hidden-mobile">
              <div class="progress termina-reg">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: item.progress + '%' }"
                  :aria-valuenow="item.progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Header from '@/components/Header.vue'

export default {
  components: {
    Header
  },
  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  mounted() {
    document.querySelector('body').classList.add('display-scrollbar')
  },
  beforeDestroy() {
    document.querySelector('body').classList.remove('display-scrollbar')
  },
  created() {
    if (
      this.game.teams === undefined ||
      this.game.teams[0]?.gameCode != this.code
    ) {
      this.fetchTeams({ code: this.code })
    }
    if (this.gameData === undefined || this.game.teamData?.id != this.team_id) {
      this.fetchTeamData({ code: this.code, teamId: this.team_id })
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to || from) {
      document.body.classList.add('black-bg')
    }

    next()
  },
  beforeRouteLeave(to, from, next) {
    if (to || from) {
      document.body.classList.remove('black-bg')
    }
    next()
  },
  data: () => ({}),
  methods: {
    ...mapActions('game', ['fetchTeams', 'fetchTeamData'])
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    gameData() {
      return this.game.teamData?.gameData
    },
    leaderboardTitle() {
      if (this.game.teamData?.eventName) {
        return this.game.teamData?.eventName
      }

      return this.gameData?.title
    },
    teams() {
      return this.game.teams
    },
    loading() {
      return this.gameData === undefined || this.game.teams === undefined
    }
  }
}
</script>
